import React from 'react';

// Container
import { OnboardingContainer } from '../../containers/OnboardingContainer/OnboardingContainer';

export function OnboardingPage() {
  return <OnboardingContainer />;
}
